import React from 'react'
import {TabsBase} from './tabs-base'
import {TabsProps} from './types'
import {useTabs} from './use-tabs'

export const Tabs = ({
  tabs,
  onChange,
  defaultActiveId,
  className,
  type = 'default',
  slim,
  tight,
  fadeable,
  canChangeTab = true,
  onClick,
  direction,
  lineClamp
}: TabsProps) => {
  const {activeId, onTabClick} = useTabs({
    onChange,
    onClick,
    defaultActiveId,
    canChangeTab
  })

  return (
    <TabsBase
      tabs={tabs}
      activeId={activeId}
      onTabClick={onTabClick}
      className={className}
      type={type}
      slim={slim}
      tight={tight}
      fadeable={fadeable}
      direction={direction}
      lineClamp={lineClamp}
    />
  )
}
